module.exports = __webpack_public_path__ + "img/zaniasLon.deb8b96d.jpg";